<template>
  <div class="topBox">
      <h3>{{project_name}}</h3>
      <div class="rBox">
          <!-- <el-badge :value="contentNum" :hidden='contentNum>0?false:true' :max="99" class="ldBox">
            <i class="el-icon-message-solid"></i>
          </el-badge> -->
          <el-dropdown>
            <div style="display:flex;align-items: center;">
              <!-- <el-image style="width: 30px; height: 30px;margin-right: 5px;border-radius: 50%;" :src="$store.state.user.avatar" fit="contain"></el-image> -->
              <span class="el-dropdown-link" style="color: #fff;">
                  <!-- <i class="el-icon-user-solid el-icon--left"></i> -->
                  {{$store.state.user.nickName}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="userinfo">个人资料</el-dropdown-item>
                <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
      </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    inject:["reload"],
    components:{

    },
    data () {
      return {
          project_name:this.$store.state.project_name,
          contentNum:12
      }
    },
    created(){  //载入前
    },
    methods:{  //业务
      //退出登录
      logout(){
        this.utils.logout()
        return
        this.http.get('/user/loginOut',{}).then((res)=>{
            if(res.data.code == 0){
              this.utils.logout()
            }
        }).catch(err=>{
            //console.log(err)
        })
      },
      //修改密码
      changePassword(){
        this.$router.push({path:'/changepassword'})
      },
      //个人资料
      userinfo(){
        this.$router.push({path:'/userinfo'})
      },
    }
  }
</script>

<style lang='scss' scoped>
.topBox{
    width: 100%;
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: center;
    background: #409EFF;
    padding: 24px;
    position: relative;
    h3{
        color: #fff;
    }
    .rBox{
      position: absolute;
      top: 18px;
      right: 30px;
    }
}
.ldBox{
  margin-right: 30px;
  cursor: pointer;
  i{
    font-size: 20px;
    color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/top/index.vue